import { Grid, Stack, Box, Text, Placeholder, HiddenFromView } from '@stitch-fix/mode-react';
const LoadingScreen = () => <Box>
    <Grid columns={{
    sm: 1,
    md: 2
  }}>
      <Box style={{
      aspectRatio: '2/3'
    }}>
        <Placeholder variant="rect" height="100%" width="100%" mb={1} />
      </Box>
      <Stack spacing={0.5}>
        <Text setting="display-xlarge">
          <Placeholder width={20} />
        </Text>
        <Text setting="title-xxlarge">
          <Placeholder width={10} />
        </Text>
        <Placeholder height="80px" width={20} />
      </Stack>
    </Grid>
    <HiddenFromView>Loading...</HiddenFromView>
  </Box>;
export default LoadingScreen;